import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { DatePicker } from 'components/shared';
import { Icon } from '@sdb/planning-ui';

const Styles = styled.div`
  width: 100%;
  position: relative;

  .remove-btn {
    position: absolute;
    left: 100%;
    margin-left: 10px;
    bottom: 0;
  }
`;

type Props = {
  initialDate?: Date | null;
  onDateChange: (date: Date | null) => void;
  disabled?: boolean;
};

export default function OptionalDatePicker({
  initialDate = null,
  onDateChange,
  disabled
}: Props) {
  const { t } = useTranslation('common');
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showPicker, setShowPicker] = useState(false);

  useEffect(() => {
    if (initialDate) {
      setShowDatePicker(true);
    }
  }, [initialDate]);

  if (showDatePicker) {
    return (
      <Styles className="end-date">
        <DatePicker
          date={initialDate}
          onChange={onDateChange}
          disabled={disabled}
          label={t('endDate')}
          open={showPicker}
        />
        {!disabled && (
          <Tooltip title={t('removeEndDate') || ''}>
            <IconButton
              size="small"
              onClick={() => {
                onDateChange(null);
                setShowDatePicker(false);
                setShowPicker(false);
              }}
              className="remove-btn"
            >
              <Icon type="xmark" />
            </IconButton>
          </Tooltip>
        )}
      </Styles>
    );
  }

  return (
    <Button
      variant="outlined"
      size="small"
      disabled={disabled}
      onClick={() => {
        setShowDatePicker(true);
        setShowPicker(true);
      }}
    >
      {t('addEndDate')}
    </Button>
  );
}
